<template>
    <div class="o-modules u-w100 u-py20 u-overflowYAuto" v-if="!loading">
        <div class="o-modules__inner u-container u-paddingButtonSize">
            <div v-if="!loading">
                <h2 class="o-modules__title u-colorSecondary">{{ $t('module.currentModules') }}</h2>
                <div class="o-modules__items" v-if="currentModules.length > 0">
                    <ModuleBlock v-for="module in currentModules" :key="module.id" :module="module" />
                </div>
                <p v-else>{{ $t('module.noCurrentModules') }}</p>

                <h2 class="o-modules__title u-colorSecondary u-mt20">
                    {{ $t('module.completedModules') }}
                    <div class="a-tag" v-if="completedModules.length > 0">
                        <span class="u-colorPrimary">
                            {{ completedModules.length }}
                        </span>
                        &nbsp;
                        {{ $t('module.completed') }}
                    </div>
                </h2>
                <div class="o-modules__items" v-if="completedModules.length > 0">
                    <ModuleBlock v-for="module in completedModules" :key="module.id" :module="module" />
                </div>
                <p v-else>{{ $t('module.noCompletedModules') }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import api from '../services/api';

// Components
import ModuleBlock from '../components/molecules/ModuleBlock.vue';

const modules = ref([]);
const loading = ref(true);

const fetchModules = async () => {
    try {
        const response = await api.get('/linked-modules');

        if (response.status === 200 && Object.keys(response.data).length !== 0) {
            modules.value = Object.values(response.data).map(module => ({
                id: module.id,
                title: module.title,
                module_duration: module.module_duration,
                progress: module.progress,
                completed: module.completed,
                current_timestamp: module.current_timestamp,
                date_completed_by: module.date_completed_by,
                module_rating: module.module_rating,
            }));
        }
        loading.value = false;
    } catch (error) {
        console.error('Error fetching modules:', error);
        loading.value = false;
    }
};

const currentModules = computed(() => modules.value.filter(module => !module.completed));
const completedModules = computed(() => modules.value.filter(module => module.completed));

onMounted(() => {
    fetchModules();
});
</script>
